// extracted by mini-css-extract-plugin
export default {"askQuestionTopText":"t2-z","yourQuestionLabel":"u2-z","notAuthedMessage":"v2-z","form":"w2-z","textarea":"x2-z","error":"y2-z","disabled":"z2-z","edited":"A2-z","submit":"B2-z"};